import { cva } from 'class-variance-authority';

export const helperClasses = cva('flex w-auto items-center gap-1');
